import 'bootstrap/dist/css/bootstrap.min.css';
import './Navbar.css';

import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import React, { useState } from 'react';

import { assest } from '../../assest/assest';

const CustomNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = (path) => {
    if (path.startsWith("#")) {
      window.location.href = path;
    } else {
      navigate(path);
    }
    setIsMenuOpen(false);
  };

  const handleButtonClick = () => {
    window.location.hash = '#book-session';
  };

  return (
    <>
      <Navbar bg="light" variant="light" expand="lg" className="custom-navbar fixed-top">
        <Container fluid>
          <Navbar.Brand as={Link} to="/">
            <img
              src={assest.H10}  // Replace with your logo image
              width="100"
              height="50"
              alt="Tutor Logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle} />
          <Navbar.Collapse id="basic-navbar-nav" in={isMenuOpen}>
            <Nav className="mx-auto custom-nav">
              <Nav.Link onClick={() => handleLinkClick('/')}>Home</Nav.Link>
              <Nav.Link onClick={() => handleLinkClick('#lahiru')}>About</Nav.Link>
              <Nav.Link onClick={() => handleLinkClick('#services')}>Services</Nav.Link>
              <Nav.Link onClick={() => handleLinkClick('#testimonial')}>Testimonials</Nav.Link>
              <Nav.Link onClick={() => handleLinkClick('#contact')}>Contact</Nav.Link>
            </Nav>
            <Button 
              variant="outline-dark" 
              className="btn-book-session ms-lg-3" 
              onClick={handleButtonClick}
            >
              Book a Session
            </Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {isMenuOpen && <div className="overlay" onClick={handleToggle}></div>}
    </>
  );
};

export default CustomNavbar;
